import { ActionMessage, DispatchFunction } from 'satcheljs';
import getPerformanceNow from './utils/getPerformanceNow';

let internalState: { currentAction: ActionTiming | null; rootActions: Timing[] } = {
    currentAction: null,
    rootActions: [],
};

const fiveMinsInMs = 5 * 60 * 1000;

export interface EventTiming {
    kind: 'event';
    type: string;
    startTime: number;
}
export interface ActionTiming {
    kind: 'action';
    type: string | undefined;
    startTime: number;
    syncDuration: number | null;
    asyncDuration: number | null;
    childActions?: Timing[];
}

export type Timing = EventTiming | ActionTiming;

export default async function (
    next: DispatchFunction,
    actionMessage: ActionMessage,
    state: typeof internalState = internalState
) {
    let newAction: ActionTiming = {
        kind: 'action',
        type: actionMessage.type,
        startTime: getPerformanceNow(),
        syncDuration: null,
        asyncDuration: null,
    };

    if (!state.currentAction) {
        // if there's no current action, then this is a root action
        state.rootActions = updateRootActions(state.rootActions, newAction);
    } else {
        // otherwise, append this action to a child action
        state.currentAction.childActions = (state.currentAction.childActions || []).concat(
            newAction
        );
    }

    let oldAction = state.currentAction;
    state.currentAction = newAction;
    setDurationsOnAction(next, actionMessage, state.currentAction);
    state.currentAction = oldAction;
}

export async function setDurationsOnAction(
    next: DispatchFunction,
    actionMessage: ActionMessage,
    action: ActionTiming
) {
    const nextCallback = next(actionMessage);
    action.syncDuration = getPerformanceNow() - action.startTime;
    await nextCallback;
    action.asyncDuration = getPerformanceNow() - action.startTime;
}

export function updateRootActions(actions: Timing[], newAction: Timing) {
    // remove all actions that ended >5min ago, and append the new action
    return [
        ...actions.filter(
            e =>
                e.startTime + ('syncDuration' in e ? e.syncDuration || 0 : 0) >=
                getPerformanceNow() - fiveMinsInMs
        ),
        newAction,
    ];
}

export function getTimingsString(state: typeof internalState = internalState) {
    return JSON.stringify(state.rootActions);
}
